import 'liquid-ajax-cart'
import {devices} from '@/utils/devices';

export default {
  name: 'global',
  store() {
    const store = {
      isPickupAvailabilityDrawerOpen: false,
      isMobileMenuVisible: false,
      isDrawerCartVisible: false,
      isPredictiveSearchVisible: false,
      isSearchVisible: false,
      device: devices[0].name as 'mobile' | 'tablet' | 'desktop',
      viewport: {vw: window.innerWidth, vh: window.innerHeight},
      prefersReducedMotion: false,
      cart: undefined as any,
      hasBodyLock: false,
      bodyLocksCount: 0,
      savedScrollY: window.scrollY,
      header: {
        height: 60 // Default header height in pixels
      },
      init() {
        this.initLiquidAJaxCart()
        this.initBundleBuilder()
        this.setDevice()
        window.addEventListener('resize', this.setDevice.bind(this), {passive: true})

        this.initPrefersReducedMotion()

        this.checkOpenCartFromUrl()
      },
      checkOpenCartFromUrl() {
        const params = new URLSearchParams(window.location.search)
        if (params.get('openCart') === 'true') {
          this.isDrawerCartVisible = true
        }
      },
      openMobileMenu() {
        this.isMobileMenuVisible = true
        this.bodyScrollLock(true)
      },
      closeMobileMenu() {
        this.isMobileMenuVisible = false
        this.bodyScrollLock(false)
      },
      toggleMobileMenu() {
        this.isMobileMenuVisible = !this.isMobileMenuVisible
        this.bodyScrollLock(this.isMobileMenuVisible)
      },
      initLiquidAJaxCart() {
        document.addEventListener('liquid-ajax-cart:request-end', (event: Event & any) => {
          const {requestState, cart} = event.detail

          if (requestState.requestType === 'add') {
            if (requestState.responseData?.ok) {
              this.isDrawerCartVisible = true
            }
          }

          this.cart = cart
        })
      },

      setDevice() {
        this.viewport.vw = window.innerWidth
        this.viewport.vh = window.innerHeight

        const currentDevice = devices.find(d => d.breakpoint < this.viewport.vw)?.name || devices[0].name
        this.device = currentDevice
      },
      bodyScrollLock(shouldLock) {
        if (shouldLock) {
          if (!this.hasBodyLock) {
            this.savedScrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this.savedScrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
            document.body.style.height = '100%';
          }
          this.bodyLocksCount += 1;
          this.hasBodyLock = shouldLock;
        } else {
          this.bodyLocksCount -= 1;

          if (this.hasBodyLock && this.bodyLocksCount === 0) {
            document.body.style.removeProperty('position');
            document.body.style.removeProperty('top');
            document.body.style.removeProperty('width');
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('height');
            window.scrollTo(0, this.savedScrollY);
            this.hasBodyLock = shouldLock;
          }
        }
      },

      clearSearchDrawer() {
        this.isSearchVisible = false;
        const input: HTMLInputElement | null = document.querySelector('[data-predictive-search-drawer-input]');
        if (input) {
          input.value = '';
          input.blur();
        }
        const predictiveWrapper = document.querySelector('.predictive-search-wrapper--drawer');
        if (predictiveWrapper) predictiveWrapper.innerHTML = '';
        const pageContainer = document.getElementById('PageContainer');
        if (pageContainer) {
          pageContainer.style.position = '';
          pageContainer.style.top = '';
          pageContainer.style.width = '';
          pageContainer.style.height = '';
          pageContainer.classList.remove('drawer');
        }
      },
      initPrefersReducedMotion() {
        const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
        mql.addEventListener("change", this.handlePrefersReducedMotionChange.bind(this), {passive: true});
        this.prefersReducedMotion = mql.matches;
      },
      handlePrefersReducedMotionChange(event: MediaQueryListEvent) {
        this.prefersReducedMotion = event.matches
      },

      async refreshCart() {
        try {
          await new Promise(resolve => setTimeout(resolve, 500));
          await window.liquidAjaxCart.update();
        } catch (error) {
          console.error('Failed to refresh cart:', error);
        }
      },

      initBundleBuilder() {
        window.bbAfterAddToCart = async () => {
          await this.refreshCart();
          this.isDrawerCartVisible = true;
        }

        document.addEventListener('bb:added-to-cart', async () => {
          await this.refreshCart();
          this.isDrawerCartVisible = true;
        });
      },


    }
    return store
  }
}
